// Canonical game document registry.
import { gameWantedDocument } from './wanted';
import { gameWildThingsDocument } from './wild-things';
import { gameOkieDokieDocument } from './okie-dokie';
import { gameMemeMashDocument } from './meme-mash';
import { gameFinishEachOthersSandwichesDocument } from './finish-each-others-sandwiches';
import { gameEgoManiacsDocument } from './ego-maniacs';
import { gameWtfIsHappeningDocument } from './wtf-is-happening';
import { gameSecondOpinionsDocument } from './second-opinions';
import { gameQuinspireDocument } from './quinspire';
import { gameTooManyCooksDocument } from './too-many-cooks';
import { gameBadBunniesDocument } from './bad-bunnies';
import { gameFeedTheFarmDocument } from './feed-the-farm';
export const gameDocuments = [
    gameWantedDocument,
    gameWildThingsDocument,
    gameOkieDokieDocument,
    gameMemeMashDocument,
    gameFinishEachOthersSandwichesDocument,
    gameEgoManiacsDocument,
    gameWtfIsHappeningDocument,
    gameSecondOpinionsDocument,
    gameQuinspireDocument,
    gameTooManyCooksDocument,
    gameBadBunniesDocument,
    gameFeedTheFarmDocument,
];
export const gameDocumentsBySlug = Object.fromEntries(gameDocuments.map((document) => [document.slug, document]));
export * from './meme-mash';
export * from './finish-each-others-sandwiches';
export * from './ego-maniacs';
export * from './wtf-is-happening';
export * from './second-opinions';
export * from './quinspire';
export * from './too-many-cooks';
export * from './bad-bunnies';
export * from './feed-the-farm';
export * from './okie-dokie';
export * from './wild-things';
export * from './wanted';
//# sourceMappingURL=index.js.map